import { EventTypeInfoDto, tribeApi } from "@app/data/tribeSwaggerApi";
import { EventsTypesResponse, EventType } from "@pages/makeEvent/steps-components/eventType-component/types.ts";
import { ioErrorOf } from "@app/data/errors";
import { EventsTypeSchema } from "@pages/makeEvent/steps-components/eventType-component/schema";

const verifyData = (data: EventTypeInfoDto[] | undefined):  EventType[] => {
  if (!data) return []
  return data.filter(f=>{
    return EventsTypeSchema.safeParse(f).success
  }).map(m=>EventsTypeSchema.parse(m))
}
export const useEventsTypes = (): EventsTypesResponse => {
  const {isLoading, error, data} = tribeApi.useGetEventTypeInfoQuery()

  return {
    isLoading: isLoading,
    error: ioErrorOf(error),
    eventTypesList: verifyData(data)
  }
}